const DraggableItems = {
	BLOCK: 'BLOCK',
	ROW: 'ROW',
	FORM_ELEMENT: 'FORM_ELEMENT',
	INPUT_FROM_GROUP: 'INPUT_FROM_GROUP'
};

export default DraggableItems;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/dnd.js